(function () {
  const PROPERTY_SELECTOR = '[data-line-item-property="Engraving Message"]';
  const YES_VALUE = "Yes";
  const ENGRAVING_NAME_PREFIX = "Engraving-";
  const SECTION_ATTR = "data-section";

  const trim = (s) => (s || "").toString().trim();

  function findClosestSectionId(el) {
    const vs = el.closest("variant-selects");
    if (vs && vs.getAttribute(SECTION_ATTR)) return vs.getAttribute(SECTION_ATTR);
    return null;
  }

  function findPropertyBlockForSection(sectionId) {
    if (sectionId) {
      const scoped = document.querySelector(
        `${PROPERTY_SELECTOR} [form="product-form-${sectionId}"], ${PROPERTY_SELECTOR} [id^="${sectionId}-"], ${PROPERTY_SELECTOR} [id*="${sectionId}"]`
      );
      if (scoped) return scoped.closest(PROPERTY_SELECTOR);
    }

    return document.querySelector(PROPERTY_SELECTOR);
  }

  function getEngravingValueForSection(sectionId) {
    const vs = sectionId
      ? document.querySelector(`variant-selects[data-section="${CSS.escape(sectionId)}"]`)
      : document.querySelector("variant-selects");

    if (!vs) return "";

    const radios = vs.querySelectorAll('input[type="radio"][name]');
    for (const r of radios) {
      if (trim(r.name).startsWith(ENGRAVING_NAME_PREFIX) && r.checked) {
        return trim(r.value);
      }
    }
    return "";
  }

  function setBlockShown(block, show) {
    if (!block) return;

    const input = block.querySelector("input, textarea, select");
    if (input) {
      input.disabled = !show;
      input.required = show;
      if (!show) input.value = "";
    }

    block.style.display = show ? "" : "none";
  }

  function updateFromAnyRadio(el) {
    const sectionId = findClosestSectionId(el);
    const val = getEngravingValueForSection(sectionId);
    const block = findPropertyBlockForSection(sectionId);
    setBlockShown(block, val === YES_VALUE);
  }

  function init() {
    document.querySelectorAll("variant-selects").forEach((vs) => {
      const sectionId = vs.getAttribute(SECTION_ATTR);
      const val = getEngravingValueForSection(sectionId);
      const block = findPropertyBlockForSection(sectionId);
      setBlockShown(block, val === YES_VALUE);
    });
  }

  document.addEventListener("DOMContentLoaded", init);

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t || t.type !== "radio" || !t.name) return;

    if (trim(t.name).startsWith(ENGRAVING_NAME_PREFIX)) {
      updateFromAnyRadio(t);
    }
  });

  document.addEventListener("theme:product-info:loaded", init);
})();

// MOBILE MENU ACCORDION (single-open)
(function () {
  document.addEventListener("click", (e) => {
    const row = e.target.closest("[data-mm-toggle-row]");
    if (!row) return;

    const menuRoot = row.closest(".drawer__main-menu") || document;
    const panelId = row.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : null;

    const isOpen = row.getAttribute("aria-expanded") === "true";

    // Close all other open rows in this menu
    menuRoot.querySelectorAll("[data-mm-toggle-row][aria-expanded='true']").forEach((other) => {
      if (other === row) return;

      other.setAttribute("aria-expanded", "false");
      const otherPanelId = other.getAttribute("aria-controls");
      const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
      if (otherPanel) otherPanel.hidden = true;
    });

    // Toggle clicked row
    row.setAttribute("aria-expanded", String(!isOpen));
    if (panel) panel.hidden = isOpen;
  });

  document.addEventListener("keydown", (e) => {
    const row = e.target.closest("[data-mm-toggle-row]");
    if (!row) return;

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      row.click();
    }
  });
})();

// FEATURED COLLECTION SLIDER ON MOBILE
(function () {
  const MARK = "data-force-desktop-slider";
  const DONE = "data-force-desktop-slider-done";
  const mqMobile = window.matchMedia("(max-width: 749px)");

  function isMobile() {
    return mqMobile.matches;
  }

  function parseJSONAttr(el, attr) {
    const raw = el.getAttribute(attr);
    if (!raw) return null;
    try {
      const decoded = raw.includes("%7B") || raw.includes("%22") ? decodeURIComponent(raw) : raw;
      return JSON.parse(decoded);
    } catch {
      return null;
    }
  }

  function getOptions(el) {
    return (
      parseJSONAttr(el, "data-options") ||
      parseJSONAttr(el, "data-slider-options") ||
      parseJSONAttr(el, "data-slider-component-options") ||
      {}
    );
  }

  function setOptions(el, opts) {
    const attr =
      el.hasAttribute("data-slider-options") ? "data-slider-options" :
      el.hasAttribute("data-slider-component-options") ? "data-slider-component-options" :
      "data-options";

    el.setAttribute(attr, JSON.stringify(opts));
  }

  function forceSameDesktopSliderOnMobile(el) {
    if (!el || el.nodeType !== 1) return;
    if (!el.hasAttribute(MARK)) return;
    if (el.hasAttribute(DONE)) return;
    if (!isMobile()) return;

    const opts = getOptions(el);
    opts.watchCSS = false;       // activate on mobile
    opts.prevNextButtons = true; // keep desktop behavior

    setOptions(el, opts);
    el.dispatchEvent(new CustomEvent("theme:slider:init", { bubbles: true }));
    el.setAttribute(DONE, "true");
  }

  function repositionFlickityArrows(slider) {
    if (!slider || !slider.flkty) return;
    slider.flkty.resize?.();
    slider.flkty.reposition?.();
    slider.dispatchEvent(new CustomEvent("theme:slider:reposition", { bubbles: true }));
  }

  function onSliderLoaded(e) {
    const slider = e.detail && e.detail.slider;
    if (!slider || !slider.hasAttribute(MARK)) return;
    if (!isMobile()) return;

    // start at first slide
    slider.flkty?.select?.(0, false, true);

    // reposition arrows a few times while images/layout settle
    let tries = 0;
    const max = 5;
    const tick = () => {
      repositionFlickityArrows(slider);
      if (++tries < max) setTimeout(tick, 200);
    };
    setTimeout(tick, 50);
  }

  function scan() {
    document.querySelectorAll(`slider-component[${MARK}]`).forEach(forceSameDesktopSliderOnMobile);
  }

  // initial + after load
  scan();
  window.addEventListener("load", () => {
    scan();
    setTimeout(scan, 200);
    setTimeout(scan, 800);
  });

  // listen once
  document.addEventListener("theme:slider:loaded", onSliderLoaded);

  // mutation observer (debounced)
  let scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }

  const mo = new MutationObserver(queueScan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


// REARRANGE SOCIETY SIGN UP
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('#Newsletter--template--18471548289194__section_newsletter_6CC3Jb');
  if (!section) return;

  const rte = section.querySelector('.hero__rte');
  const form = section.querySelector('form.newsletter-form');
  if (!rte || !form) return;

  const submitRow = form.querySelector('.newsletter__submit')?.closest('.input-row');
  if (!submitRow) return;

  form.insertBefore(rte, submitRow);
});

// KEEPS "NOTIFY ME WHEN AVAILABLE" POPUP IN SYNC WITH THE SELECTED VARIANT
(function () {
  if (typeof subscribe !== 'function' || !window.theme || !theme.PUB_SUB_EVENTS) return;
  subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
    var v = event && event.data && event.data.variant;
    if (!v) return;
    var input = document.querySelector('[data-notification-product]');
    var title = document.querySelector('product-notification [data-variant-title]');
    if (input) input.value = v.name;
    if (title) title.textContent = v.title;
  });
})();